import React from 'react';

const PrinterStatusAlerts = ({
  wsError,
  clientStatus,
  printersError,
  onCheckStatus
}) => {
  return (
    <>
      {wsError && (
        <div className="bg-red-50 dark:bg-red-900/50 border border-red-200 dark:border-red-800 rounded-lg p-4 text-red-700 dark:text-red-300">
          Error de conexión: {wsError.message}
        </div>
      )}

      {clientStatus === 'stopped' && (
        <div className="bg-yellow-50 dark:bg-yellow-900/50 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-300">
                Cliente de Impresión Detenido
              </h3>
              <p className="mt-1 text-sm text-yellow-700 dark:text-yellow-400">
                El cliente de impresión no está ejecutándose. Por favor, inicie el cliente para poder escanear e imprimir.
              </p>
            </div>
            <button
              onClick={onCheckStatus}
              className="ml-4 px-3 py-1 text-sm bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-300 rounded hover:bg-yellow-200 dark:hover:bg-yellow-800"
            >
              Verificar Estado
            </button>
          </div>
        </div>
      )}

      {printersError && (
        <div className="bg-red-50 dark:bg-red-900/50 border border-red-200 dark:border-red-800 rounded-lg p-4 text-red-700 dark:text-red-300">
          Error cargando impresoras: {printersError}
        </div>
      )}
    </>
  );
};

export default PrinterStatusAlerts; 